import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder } from '../../actions/purchaseOrders_actions';

import ReceiveModal from '../../components/Inventories/receiveModal';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  if (values.IsEnabled === null ) {
      errors.IsEnabled = 'Required'
  } 
  return errors
}


let receiveModal = reduxForm({
    form: 'receiveModal',
})(ReceiveModal);

const selector = formValueSelector('receiveModal')

function mapStateToProps(state) {
    const purchaseOrderValue = selector(state, 'PurchaseOrder_id');
    return {
        purchaseOrderValue: purchaseOrderValue,

        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
        purchaseOrders: state.purchaseOrders.all,
        isLoading: state.purchaseOrders.isLoading,
        error: state.purchaseOrders.error
    }
}

export default connect(mapStateToProps, { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder })(receiveModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/receiveModal.jsx